import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem("token") || "",
    userInfo: JSON.parse(localStorage.getItem("info") || "null"),
    site: JSON.parse(localStorage.getItem("Site") || "null")
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      if (token) {
        localStorage.setItem("token", token)
      } else {
        localStorage.removeItem("token")
      }
    },
    SET_USER_INFO(state, info) {
      state.userInfo = info
      if (info) {
        localStorage.setItem("info", JSON.stringify(info))
      } else {
        localStorage.removeItem("info")
      }
    },
    SET_SITE(state, site) {
      state.site = site
      if (site) {
        localStorage.setItem("Site", JSON.stringify(site))
      } else {
        localStorage.removeItem("Site")
      }
    }
  },
  actions: {
    logout({ commit }) {
      commit("SET_TOKEN", "")
      commit("SET_USER_INFO", null)
    },
    async ensureProfile({ state, commit }) {
      if (!state.token) return null
      if (state.userInfo && state.userInfo.userId) return state.userInfo
      try {
        const { getUserProfile } = require("@/api/index")
        const res = await getUserProfile()
        const info = (res && res.data) || null
        commit("SET_USER_INFO", info)
        return info
      } catch (e) {
        return null
      }
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    siteId: state => state.site && state.site.id
  }
})
